<template>
<div class="container-icons">
  <div class="icon__roubo" :class="icon">
    <img src="@/assets/svg/icone-roubo.svg" alt="Roubo e Furto"/>
    Roubo e furto
  </div>
  <div class="icon-v">&#10003;</div>
  <div :class="icon">
    <img src="@/assets/svg/icone-quebra.svg" alt="Quebra"/>
    <span>Quebra</span>
  </div>
  <div :class="iconV" v-if="iconvOrx">✘</div>
  <div :class="iconV" v-else>&#10003;</div>
  <div :class="icon">
    <img src="@/assets/svg/icone-liquido.svg" alt="Líquido"/>
    <span>Líquido</span>
  </div>
  <div :class="iconV" v-if="iconvOrx">✘</div>
  <div :class="iconV" v-else>&#10003;</div>
</div>
</template>

<script>
import './Icons.css'
export default {
  props: {
    icon: String, // passar o nome da classe desajada(icon ou icon-resume)
    iconV: String, // passar a classe do icone quando na pagina principal passar na prop "icon-v"
    iconvOrx: Boolean, // passar na prop como falso, será verdadeira somente quando somenteRoubo for verdadeiro
    disabled: Boolean
  }
}
</script>
